import { createApp } from 'JIX/vue-sentry.js';
import JobText from 'JIX/components/AiApplyHelper/JobText.vue';

const stash = window.Stash['ai_apply_helper/jobtext'];
const app = createApp(JobText, { humanjobid: stash.humanjobid });

app.mount("#ai-apply-helper-jobtext");
